const mrIN= {
    login: {
      title: 'साइन इन करा',
      sign_in_btn: 'साइन इन करा'
    },
    bar: {
        logout: 'लॉग आउट',
        languages: 'भाषा',
        settings: 'ओपन सेटिंग्ज'
    },
    language: {
      name: 'इंग्रजी (यूएस)',
    },
    attributePage: {
        title: 'ॲट्रिब्यूट बदल',
        viewChanges: 'बदल पहा',
        dateTime: 'तारीख',
        notificationType: 'सूचना प्रकार',
        notificationValue: 'सूचना मूल्य',
        oldValue: 'जुने मूल्य',
        newValue: 'नवीन मूल्य',
        accept: 'स्वीकारा',
        reject: 'नकार द्या',
    },
    Home: 'होम',
    load: 'प्रारंभिक लोड करत आहे...',
    Requested: "विनंती केली",
    Viewed: "पाहिले",
    Executing: "अंमलात आणत आहे",
    Completed: "पूर्ण झाले",
    Expired: "कालबाह्य",
    Cancelled: "रद्द केले",
    Error: "त्रुटी",
    Rejected: "नाकारले",
    error: 'काहीतरी चुकीचे घडले; कृपया पुन्हा प्रयत्न करा.',
    displayname: 'डिस्प्ले नाव',
    givenname: 'नाव',
    surname: 'आडनाव',
    email: 'ईमेल',
    mail: 'ईमेल',
    name: 'नाव',
    firstname: 'नाव',
    lastname: 'आडनाव',
    footer_copyright: 'सर्व हक्क राखीव.'
  };
  
  export default mrIN;
  